import Cookies from 'js-cookie';
import { IToken } from '@modules/auth/domain/model/auth.model';
import { GetProductRelatedProductQueryDocument, GetProductRelateProductByInterestingDocument, ProductResponse } from '@modules/libs/graphql/generated/graphql';
import { gqlQuery } from '@modules/libs/graphql/gql-config';
import { IProductRelatedProductRepository } from '@modules/products/application/ports/relatedProduct.repository.port';
import { getAuthCookiesName } from '@shared/helpers/getAuthCookiesName.helper';
import { left, right } from '@shared/utils/either.utils';
import { ProductRelatedProductEntityMapper } from '../../outbound/ports/relatedProduct.mapper';
export class ProductRelatedProductRepositoryImpl implements IProductRelatedProductRepository {
  async getRelatedProduct(productId: number): IProductRelatedProductRepository.getRelatedProductOutput {
    try {
      const {
        data
      } = await gqlQuery({
        query: GetProductRelatedProductQueryDocument,
        variables: {
          data: {
            productId
          }
        }
      });
      const output = data.getProductRelateProduct.map((relatedProduct: ProductResponse) => {
        return ProductRelatedProductEntityMapper.toDomain(relatedProduct);
      });
      return right(output);
    } catch (err) {
      console.error('Error ProductRelatedProductRepositoryImpl.getRelatedProduct', err);
      return left(err);
    }
  }
  async getRelatedProductWithPersonalized(productId: number): IProductRelatedProductRepository.getRelatedProductOutput {
    try {
      const cookies = Cookies.get(getAuthCookiesName());
      const tokens = cookies && JSON.parse(cookies) as IToken;
      const {
        data
      } = await gqlQuery({
        query: GetProductRelateProductByInterestingDocument,
        headers: {
          authorization: tokens.jwt ? `Bearer ${tokens.jwt}` : ''
        },
        variables: {
          where: {
            productId
          }
        }
      });
      const output = data.getProductRelateProductByInteresting.map((relatedProduct: ProductResponse) => {
        return ProductRelatedProductEntityMapper.toDomain(relatedProduct);
      });
      return right(output);
    } catch (error: any) {
      console.error('error ProductRelatedProductRepositoryImpl.getRelatedProductWithPersonalized', error);
      return left(error);
    }
  }
}